export const conversionsKeys = {
  all: ["conversions"] as const,
  details: () => [...conversionsKeys.all, "detail"] as const,
  detail: (id: string) => [...conversionsKeys.details(), id] as const,
};

export const creditsKeys = ["credits"] as const;

const DEFAULT_PAGE_SIZE = 5;

export const DEFAULT_FILTERS = {
  pageSize: DEFAULT_PAGE_SIZE,
};


export const dataKeys = {
  countries: ["countries"] as const,
  gradingScales: ["gradingScales"] as const,
};
